/**
 * Decide what the document preview summary section should show.
 * Keywords-only pages must not show the "No page summary" empty state.
 */
export function resolveDocumentPreviewSummarySection(args: {
  showPageMetadata: boolean
  isPageLoading: boolean
  summary: string
  keywords: readonly string[]
}): {
  showSummarySection: boolean
  showNoPageSummary: boolean
} {
  const { showPageMetadata, isPageLoading, summary, keywords } = args
  const showNoPageSummary =
    showPageMetadata && !isPageLoading && !summary && keywords.length === 0
  return {
    showNoPageSummary,
    showSummarySection:
      Boolean(summary) || keywords.length > 0 || showNoPageSummary,
  }
}
